import { useState } from 'react';

const useLoading = (initState = false) => {
  const [isLoading, setLoading] = useState(initState);

  const openLoading = () => {
    setLoading(true);
  };

  const closeLoading = () => {
    setLoading(false);
  };

  return [
    isLoading,
    openLoading,
    closeLoading,
  ];
};

export default useLoading;
